export enum ACTIVITY_BULK {
	SEND_QUESTIONNAIRE_MESSAGE = 'sendQuestionnaireMessage',
    SEND_PUSH_MESSAGE = 'sendPushMessage',
    SEND_EDUCATIONAL_MESSAGE = 'sendEducationalMessage',
    SEND_MESSAGE = 'sendMessage',
    SEND_SMS = 'sendSMS'
}

export interface DataBulkAction {
	[key: string]: any
	title?: string
	text?: string | null | undefined
	body?: string
    link?: string
    linkText?: string
}

export interface DataBulkActionRequest {
	activity?: String
    data?: DataBulkAction
    criteria?: any
}

export interface BulkActionState {
	message: String | null | undefined,
    bulkAction: DataBulkActionRequest | null | undefined
}

export enum BULK_ACTION_TYPES {
	SET_MESSAGE_WRITING = 'SET_MESSAGE_WRITING',
    EXECUTE_BATCH_BULK_ACTION = 'EXECUTE_BATCH_BULK_ACTION',
    CREATE_BULK_ACTION = 'CREATE_BULK_ACTION'
}

export interface SetMessageWriting {
	type: BULK_ACTION_TYPES.SET_MESSAGE_WRITING
	payload: String | null
}

export interface ExecuteBatchBulkAction {
	type: BULK_ACTION_TYPES.EXECUTE_BATCH_BULK_ACTION
}

export interface CreateBulkAction {
	type: BULK_ACTION_TYPES.CREATE_BULK_ACTION,
    payload: DataBulkActionRequest
}

export type BulkActionOnAction =
	| SetMessageWriting
    | ExecuteBatchBulkAction
    | CreateBulkAction